import ProjectProperties, {ProjectAvailableMenuOptions} from "../project-properties"
import projectProperties_toJSON from "../functions/properties-to-json"
import ProjectSession from "../../project-session"
import {ProjectPropertiesData} from "../../types"

const DEFAULT = {
    canCreateTask           : false,
    canCreateProject        : true,
    // canCreatePage           : false,
    canCreateLink           : true,
    canCreateEmbed          : true,
    canCreateMeeting        : false,
    canCreateEvent          : false,
    canCreateDiscussion     : false,
    canCreateDocument       : false,
    canCreateGoal           : false,
    canCreateDashboard      : false,
    canCreateRequestForms   : false,
    canCreateAttachments    : false,
}

export default class ProjectSectionProperties extends ProjectProperties {

    constructor(properties:any, project: ProjectSession) {
        super(properties, project)

        this.canCreateTask                          = DEFAULT.canCreateTask
        this.canCreateProject                       = _.get(properties,'canCreateProject', DEFAULT.canCreateProject)
        // this.canCreatePage                          = _.get(properties,'canCreatePage', DEFAULT.canCreatePage)
        this.canCreateLink                          = _.get(properties,'canCreateLink', DEFAULT.canCreateLink)
        this.canCreateEmbed                         = _.get(properties,'canCreateEmbed', DEFAULT.canCreateEmbed)
        this.canCreateMeeting                       = DEFAULT.canCreateMeeting
        this.canCreateEvent                         = DEFAULT.canCreateEvent
        this.canCreateDiscussion                    = DEFAULT.canCreateDiscussion
        this.canCreateDocument                      = DEFAULT.canCreateDocument
        this.canCreateGoal                          = DEFAULT.canCreateGoal
        this.canCreateDashboard                     = DEFAULT.canCreateDashboard
        this.canCreateRequestForms                  = DEFAULT.canCreateRequestForms
        this.canCreateAttachments                   = DEFAULT.canCreateAttachments
        this.canHaveStatus                          = false

        this.menuSections.reports                   = false
        this.menuSections.integrations              = false
        this.menuSections.automations               = false
        this.menuSections.customers                 = false

        this.settingsSections.workItems             = false
        this.settingsSections.taskTypes             = false
        this.settingsSections.customFields          = false
        this.settingsSections.views                 = false
        this.settingsSections.taskId                = false
        this.settingsSections.navigation            = false
        this.settingsSections.tasksWorkflowBlock    = false
    }

    get availableMenuOptions(): ProjectAvailableMenuOptions {
        return {
            pinStar         : false,
            info            : true,
            users           : true,
            settings        : true,
            status          : false,
            history         : true,
            rename          : true,
            editSource      : false,
            colorIcon       : true,
            move            : false,
            convert         : true,
            duplicate       : true,
            saveAsTemplate  : false,
            delete          : true,
            archive         : false,
            directLink      : false,
            showInMenu      : false,
        }
    }

    get handleExpandInsteadOfOpen() {
        return true
    }

    toJSON(): ProjectPropertiesData {
        return projectProperties_toJSON(this, DEFAULT)
    }
}
